import LegalPageLayout from './LegalPageLayout'
import { contactWhatsAppUrl, youtubeChannelUrl } from './siteDestinations'

/** A caixa de ideia do Rogério saiu da landing em 18/09/2026; a seção sobre ela só aparece se a experiência voltar. */
export default function PrivacyPage({ rogerioEnabled = false }: { rogerioEnabled?: boolean } = {}) {
  return (
    <LegalPageLayout eyebrow="Privacidade" title="Política de Privacidade" updated="28 de setembro de 2026">
      <p className="legal-page__intro">
        Esta política descreve o uso do site da Oficina IA.
      </p>

      <section aria-labelledby="privacy-page-controller">
        <h2 id="privacy-page-controller">Responsável e canal</h2>
        <p>
          Arthur Fischer é o responsável pela Oficina IA e pelas decisões sobre o tratamento de dados nesta
          landing. Para falar sobre privacidade, use o WhatsApp real da Oficina IA:{' '}
          <a href={contactWhatsAppUrl} target="_blank" rel="noopener noreferrer">Falar com Arthur</a>.
        </p>
      </section>

      <section aria-labelledby="privacy-page-data">
        <h2 id="privacy-page-data">Dados na landing</h2>
        <p>
          {rogerioEnabled ? 'O Rogério pode ser usado sem criar conta ou fazer pagamento. ' : 'A landing não inclui formulário, conta, pagamento nem chat. '}
          Eu uso o Cloudflare Web Analytics
          para contar visitas de forma agregada, sem cookies e sem identificar quem visita.
        </p>
      </section>

      <section aria-labelledby="privacy-page-ads">
        <h2 id="privacy-page-ads">Medição de anúncios e sua escolha</h2>
        <p>Na Oficina IA, usamos o Google Ads para relacionar anúncios a cliques na agenda e no WhatsApp,
          distinguindo a página para empreendedores das demais páginas.
          A tag do Google é carregada em todas as visitas, mas funciona sem cookies de anúncio até você
          escolher “Aceitar” no aviso de cookies. Enquanto você não aceita, ou se recusar, nenhum cookie de
          anúncio é gravado, e o Google recebe apenas avisos sem cookies de que houve uma visita ou um clique,
          com informações técnicas como endereço IP e navegador, usados para estimar resultados de anúncios
          de forma agregada. Você pode recusar e continuar usando a página, a agenda e os links de contato.</p>
        <p>Se você aceitar, o Google pode receber também identificadores de clique do anúncio e cookies de
          atribuição. Os eventos indicam apenas o
          clique no botão; não confirmam uma reserva nem uma conversa. Não enviamos o texto do WhatsApp,{' '}
          {rogerioEnabled ? 'relatos ao Rogério, ' : ''}nome, e-mail ou telefone como dados desses eventos. A personalização de
          anúncios e as conversões otimizadas com dados pessoais não são habilitadas por esta integração.</p>
        <p>Sua escolha fica guardada neste navegador por até 180 dias. Você pode alterá-la em
          “Preferências de cookies”, no rodapé. Ao recusar depois de permitir, removemos os cookies
          de atribuição do Google Ads acessíveis neste domínio, e a tag volta a funcionar sem cookies de
          anúncio; isso não apaga dados que já tenham sido recebidos pelo Google.</p>
        <p>O processamento pode ocorrer fora do Brasil e segue também a{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Política de Privacidade do Google</a>.
          Consulte{' '}<a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">como o Google usa dados de sites parceiros</a>.
          Os prazos dos registros no Google dependem das configurações e políticas desse serviço.</p>
      </section>

      {rogerioEnabled && <section aria-labelledby="privacy-page-rogerio">
        <h2 id="privacy-page-rogerio">O que você conta ao Rogério</h2>
        <p>Ao pedir ideias, o texto que você escreveu é enviado à infraestrutura de IA da Cloudflare
          para preparar as sugestões. O guia combina esse contexto com modelos prontos.
          Os exemplos animados do campo são apenas sugestões visuais e não são enviados como seu pedido.</p>
        <p>Não inclua senhas, dados pessoais de outras pessoas ou informações privadas que não sejam
          necessárias para explicar sua ideia. Seu pedido e os resultados não são enviados automaticamente ao Arthur.</p>
        <p>O serviço aplica limites de uso e usa dados técnicos de conexão para conter excesso de pedidos.
          O endereço de rede é transformado em uma chave para essa verificação. O aplicativo não registra
          seu relato nem os resultados em logs de conteúdo; a Cloudflare pode processar registros técnicos
          conforme sua infraestrutura e suas políticas.</p>
      </section>}

      <section aria-labelledby="privacy-page-access">
        <h2 id="privacy-page-access">Acesso técnico</h2>
        <p>
          A Cloudflare hospeda e protege o site e os vídeos próprios. Quando disponível, o vídeo de
          apresentação só começa a ser baixado ao acionar a reprodução. Para entregar e proteger a página, ela pode processar
          dados técnicos de conexão, como endereço IP, informações do navegador e registros de segurança.
        </p>
      </section>

      <section aria-labelledby="privacy-page-storage">
        <h2 id="privacy-page-storage">Armazenamento e processamento</h2>
        <p>
          A Oficina IA não mantém um banco de dados próprio de visitantes nesta versão. Os registros técnicos
          processados pela Cloudflare seguem as configurações, os prazos e a infraestrutura internacional desse
          serviço.
        </p>
        {rogerioEnabled && <>
          <p>Seu último texto, as ideias e os guias abertos ficam salvos neste navegador para você retomar.
            A experiência pode ser restaurada por até 30 dias após a última alteração; dados vencidos são
            descartados na próxima abertura. Não há sincronização entre computadores ou celulares.</p>
          <p>Use “Apagar e começar de novo” para remover essa experiência. Se o navegador impedir o
            armazenamento ou a limpeza, a página avisa. Em um computador compartilhado, apague os dados
            ao terminar. Você também pode removê-los nas configurações do navegador.</p>
          <p>O PDF é montado no seu navegador. Depois do download, o arquivo fica sob seu controle e não é
            removido pelo botão de apagar a experiência. Confira o conteúdo antes de compartilhar.</p>
        </>}
      </section>

      <section aria-labelledby="privacy-page-external">
        <h2 id="privacy-page-external">YouTube e links externos</h2>
        <p>
          O vídeo de apresentação de Arthur é servido pelo próprio site e só carrega quando você dá play.
          O canal no YouTube aparece como link no rodapé: ao abrir, aplicam-se as políticas do YouTube.
        </p>
        <p>
          O <a href={youtubeChannelUrl} target="_blank" rel="noopener noreferrer">canal da Oficina IA no YouTube</a>{' '}
          e o WhatsApp são serviços externos e aplicam suas próprias políticas. Nos links de WhatsApp, uma
          mensagem inicial é apenas preparada: ela só é enviada se você decidir enviá-la no próprio WhatsApp.
        </p>
        <p>
          A primeira conversa é marcada no Google Agenda, em outra aba, com política própria.
          O nome, o e-mail e a resposta opcional sobre sua ideia ficam na agenda de Arthur e servem para
          preparar, confirmar e lembrar a conversa. A reserva gera um link do Google Meet.
          {rogerioEnabled ? 'Você pode usar “Copiar ideia” no Rogério e colar o texto no formulário, se quiser. ' : ''}
          O link da agenda não leva dados seus na URL.
        </p>
      </section>

      <section aria-labelledby="privacy-page-rights">
        <h2 id="privacy-page-rights">Seus direitos</h2>
        <p>
          Você pode pedir informações, confirmação de tratamento, acesso, correção ou eliminação de dados
          pessoais, quando aplicável. Use o canal de contato indicado nesta página para fazer o pedido sem custo.
        </p>
      </section>
    </LegalPageLayout>
  )
}
